import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import API_ROUTES from "../../../api-routes";
import apiService from "../../../services/service";

const initialState = {
  loadingAttachments: true,
  document_folders: [],
};

export const fetchAttachments = createAsyncThunk(
  "attachmentsSlice/fetchAttachments",
  async ({ id, process, entity }) => {
    // todo is this in use?
    const data = await apiService(API_ROUTES.FETCH_FILES, "POST", {
      replace: { id },
      body: {
        tags: {
          process: [process],
          entity: [entity],
        },
      },
    });
    return data;
  },
);

export const fetchDocumentFolders = createAsyncThunk(
  "attachmentsSlice/fetchDocumentFolders",
  async (payload, thunkAPI) => {
    try {
      return await apiService(API_ROUTES.FETCH_DOCUMENT_FOLDERS, "GET", {
        replace: { id: payload },
      });
    } catch (e) {
      return thunkAPI.rejectWithValue(e.message);
    }
  },
);

const attachmentsSlice = createSlice({
  name: "attachmentsSlice",
  initialState,
  reducers: {
    setAttachmentData: (state, { payload }) => {
      state[payload.key] = payload.value;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchAttachments.pending, () => {})
      .addCase(fetchAttachments.fulfilled, (state, { payload }) => {
        state.processAttachments = payload.data.sort(
          (a, b) => new Date(b.createdAt) - new Date(a.createdAt),
        );
        state.loadingAttachments = false;
      })
      .addCase(fetchAttachments.rejected, () => {})

      .addCase(fetchDocumentFolders.pending, () => {})
      .addCase(fetchDocumentFolders.fulfilled, (state, { payload }) => {
        state.document_folders = payload.data;
      })
      .addCase(fetchDocumentFolders.rejected, () => {});
  },
});
export const { setAttachmentData } = attachmentsSlice.actions;
export default attachmentsSlice.reducer;
